// import {window} from 'browser-monads';
import { useState } from "react";


const useLocalStorageNumber = (key, maxValue = 0, initialValue = 0) => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {

    if (typeof window !== 'undefined'){
      try {
        // Get from local storage by key
        const item = window.localStorage.getItem(key);
        // Parse stored json or if none return initialValue
        const returnItem = item ? JSON.parse(item) : initialValue;
        return Math.min(maxValue, returnItem);
      } catch (error) {
        // If error also return initialValue
        console.log(error);
        return Math.min(maxValue, initialValue);
      }
    } else {
      return 0;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = value => {
    if (typeof window !== 'undefined') {

      try {
        // Allow value to be a function so we have same API as useState
        const valueToStore =
          value instanceof Function ? value(storedValue) : value;
        // Save state
        setStoredValue(valueToStore);
        // Save to local storage
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {
        // A more advanced implementation would handle the error case
        console.log(error);
      }
    } else {

    }
  };

  return [storedValue, setValue];
}

export default useLocalStorageNumber;
